// extracted by mini-css-extract-plugin
export default {"table":"TicketRefundSummary_table__q2QVj","adjustment":"TicketRefundSummary_adjustment__pge7Z","checkbox":"TicketRefundSummary_checkbox__iByB5"};